import React from 'react';
import { ShimmerAvatar } from '@pitchero/react-ui';

const ScoreCardLoadingState = () => <ShimmerAvatar size={48} />;

export default ScoreCardLoadingState;
